import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';

var _React$createContext = React.createContext(false),
    Provider = _React$createContext.Provider,
    RippleConsumer = _React$createContext.Consumer;

export var RippleContext = function RippleContext(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      navigatingByKeyboard = _useState2[0],
      changeStatus = _useState2[1];

  useEffect(function () {
    var mouseDownHandler = function mouseDownHandler() {
      return changeStatus(false);
    };

    var keyUpHandler = function keyUpHandler() {
      return changeStatus(true);
    };

    document.addEventListener('mousedown', mouseDownHandler);
    document.addEventListener('keyup', keyUpHandler);
    return function () {
      document.removeEventListener('mousedown', mouseDownHandler);
      document.removeEventListener('keyup', keyUpHandler);
    };
  }, []);
  return React.createElement(Provider, {
    value: navigatingByKeyboard
  }, children);
};
export { RippleConsumer };